module.exports = __webpack_public_path__ + "img/order-follower-img-767.8a0568df.svg";